module.exports = __webpack_public_path__ + "static/img/alpfoodway_background8_resized.8c38b56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpfoodway_images/alpfoodway_background8_resized.jpg
// module id = VlXi
// module chunks = 1